// extracted by mini-css-extract-plugin
export default {"disabledIcon":"GenerateWithAIButton_disabledIcon__Ul-wJ","aiButton":"GenerateWithAIButton_aiButton__avog+"};